"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSegmentsFromFormat = exports.daysInMonth = void 0;

var _interfaces = require("./interfaces");

var getSegmentsFromFormat = function getSegmentsFromFormat(format, separator) {
  var out = [];
  format.split(separator).forEach(function (segment) {
    var segmentKey = segment.replace(/[^YMD]/g, '')[0];

    switch (segmentKey) {
      case 'Y':
        out.push(_interfaces.DateTimeSegment.Year);
        break;

      case 'M':
        out.push(_interfaces.DateTimeSegment.Month);
        break;

      case 'D':
        out.push(_interfaces.DateTimeSegment.Day);
        break;

      default:
        break;
    }
  });
  return out;
}; // Assumes month is 1-indexed. So month 1 === January


exports.getSegmentsFromFormat = getSegmentsFromFormat;

var daysInMonth = function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
};

exports.daysInMonth = daysInMonth;